import { HideAllLinesCommand } from "slotworks/commands/lines/hide-all-lines-command";
import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import { Services } from "slotworks/services/services";
import { HoldSpinControl } from "slotworks/smart-ui/controls/spin/hold-spin-control";
import SmartUIFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import State from "slotworks/state-machine/states/state";
import Timer from "slotworks/utils/timer";

export default class Idle extends State {

    public static HOLD_SPIN_DELAY: number = 0;

    private holdSkipTimer: number;

    public onEnter() {
        SmartUIFlags.set(SmartUIFlag.IDLE, true);

        Services.transaction.setBalance(GameState.getCurrentGame().balance);
    }

    public onSkip() {
        if (!this.holdSkipTimer) {
            if (HoldSpinControl.isHeld) {
                this.holdSkipTimer = Timer.setTimeout(() => {
                    this.holdSkipTimer = null;
                    this.skip();
                }, Idle.HOLD_SPIN_DELAY);
            } else {
                this.skip();
            }
        }
    }

    public onExit() {
        Components.matrix.resetSymbols();

        HideAllLinesCommand().execute();

        SmartUIFlags.set(SmartUIFlag.IDLE, false);
    }
}
